import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
function CareersCard(props) {
    const { t, i18n } = useTranslation();
    return (
        <div
            className={`career-card ${
                i18n.language === 'en' ? 'text-left' : ''
            }`}
        >
            <div className='d-flex career-mobile'>
                <div className='flex-grow-1'>
                    <div className='career-card-text'>
                        <h1> {props.name} </h1>
                        <h6
                            dangerouslySetInnerHTML={{
                                __html: props.description,
                            }}
                        ></h6>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    <Link to={props.form_url}>
                        <button className='register-btn'>
                            {t('careers.apply')}
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default CareersCard;
